import { render, staticRenderFns } from "./communitySettingManageList.vue?vue&type=template&id=38df1758&scoped=true"
import script from "./communitySettingManageList.vue?vue&type=script&lang=js"
export * from "./communitySettingManageList.vue?vue&type=script&lang=js"
import style0 from "./communitySettingManageList.vue?vue&type=style&index=0&id=38df1758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df1758",
  null
  
)

export default component.exports